import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import { Btn, CustomModal, InputText } from '../../../../../components'
import useModalCompaniesGroup, { LOAD_MESSAGE } from './ModalCompanyGroupHook'
import { hideLoadingBox, showMessageBox } from '../../../../../store/actions/system.actions'

function ModalCompanyGroup({ dispatch, show, data, selectedTp, onModalSave, onModalClose }) {
  const { state, localDispatch } = useModalCompaniesGroup()

  useEffect(() => {
    if (show) localDispatch.onInit(data)
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(hideLoadingBox())
        localDispatch.createCompanyGroup(state.company)
        break

      case LOAD_MESSAGE.UPDATE:
        dispatch(hideLoadingBox())
        localDispatch.updateCompanyGroup(state.company)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.updatedCompany)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header={`${state.company.id ? 'Editando' : 'Novo'} Grupo de Empresas`}
      isVisible={show}
      width={300}
      onClose={onModalClose}
    >
      <form className="p-grid" style={{ width: 300 }}>
        <div className="p-col-10">
          <InputText
            label="Nome :*"
            marginTop={10}
            value={state.company.name}
            onChange={value => localDispatch.onInputChange(value.toUpperCase())}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClick(state.company)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalCompanyGroup)
